export default __webpack_public_path__ + "static/cravings-f9e6fceced1291b88957718bd939e266.png";